import React from 'react';
import fr from 'facet-rest';
import {
  FDBodyText, FDClickableText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import { AlertRel } from 'Views/Authentication/Components/AlertRel';
import { useMFAResetInitiation } from 'Views/Authentication/Components/useMFAResetInitiation';
import { dataAttrs } from 'Helpers/Testing';

const Details = ({ base, prompt, onClick }) => {
  const [before, after] = base.split('{{prompt}}');

  return (
    <FDBodyText
      size={'sm'}
      value={
        <span>{before}<FDClickableText
          {...dataAttrs('')}
          appearance={'standalone'}
          onClick={onClick}
          label={prompt}
        />{after}
        </span>
      }
    />
  );
};

Details.defaultProps = {
  prompt: undefined,
  onClick: undefined,
};

Details.propTypes = {
  base: PropTypes.string.isRequired,
  prompt: PropTypes.string,
  onClick: PropTypes.func,
};

export const MFAResetButton = () => {
  const { resource } = useMetaLayoutContext();
  const { onClickStartReset, relationship, ok } = useMFAResetInitiation(resource, fr.relationships.mfaResetLink.name);

  if (!ok) {
    return null;
  }

  return (
    <AlertRel
      relationship={relationship}
      onClick={onClickStartReset}
    />
  );
};
